<template>
  <div>
    <el-dialog
      :visible.sync="vanpopup"
      custom-class="popup__box w660"
      :show-close="false"
    >
      <div slot="title" class="popup__box__title">
        <div class="popup__header">
          <div class="popup__header__top">
            <div class="pop-title" style="height: 50px;">
              <div class="pop-title__left">
                <span class="pop-title__left__text">玩法说明</span>
              </div>
              <div class="pop-title__right">
                <div class="pop-close" @click="vanpopup = false">
                  <img src="@/assets/style/desktop/img/close.svg" alt="">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="popup__box__content">
        <div class="article">
          <p class="article__title">1. 总和: 所有七个开奖号码加总</p>
          <p>◎大小: 大于或等于175，小于或等于174</p>

          <p>◎单双: 能被2整除的数为“双”，反之，为“单”</p>

          <p>◎七色波：以开出的7个色波，那种颜色最多为中奖。</p>

          <p>开出的6个正码各以1个色波计，特别号以1.5个色波计。</p>

          以下3种结果视为和局

          <p>6个正码开出3蓝3绿，而特别码是1.5红</p>

          <p>6个正码开出3蓝3红，而特别码是1.5绿</p>

          <p>6个正码开出3绿3红，而特别码是1.5蓝</p>

          <p>◎ 总肖: 当期所有正码与特码开出的不同生肖总数。</p>

          <p>例如:</p>

          <p>当期号码为19、24、12、34、40、39 特别号：49，总计六个生肖，总肖则为【6】(注意：49号亦算输赢，不为和)</p>

          <p class="article__title">2. 正,特码</p>
          <p>两面</p>
          <p>◎大小: 01~24为小，25~48为大，49则为和</p>
          <p>◎单双: 能被2整除的数为“双”，反之，为“单”, 49则视为“和”</p>

          <p>合数: 特码的个位加上十位之和</p>

          <p>◎大小: 大于或等于7为大，和数小于或等于6为小, 特码为49时视为和</p>

          <p>◎单双: 能被2整除的数为双，反之，为单，特码为49时视为和</p>

          <p>尾数</p>

          <p>◎大小: 5尾~9尾为大，0尾~4尾为小，特码为49时视为和</p>

          <p class="article__title">3. 半波、半半波</p>

          <p>◎半波：以特码色波和特单，特双，特大，特小为一个投注组合，若当期特码开出49号，则视为和局</p>

          <p>◎半半波：以特码色波和特码单双及特码大小等三种游戏为一个投注组合，若当期特码开出49号，则视为和局</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ExplainDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    vanpopup: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  height: 50vh;
  overflow-y: auto;
}
/deep/ {
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    color: #000;
  }
}
</style>
